import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { moduleRoutes } from './urlmap';
import { ApplicationHttpClient } from './../http-client';

@Injectable()
export class AdministratorService {
  private mapRoutes = moduleRoutes;

  constructor(
    private http: ApplicationHttpClient,
  ) { }

  getList(): Observable<any> {
    return this.http.Get(this.mapRoutes.list);
  }
}
